/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Mission } from '../models/Mission';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class GetService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Create or update a mission
   * The preferred method to create or update missions is `PUT /missions/{id}`.
   * If your architecture does not allow you to maintain a mapping between
   * your system's mission IDs and those from this API, you can use the `POST`
   * method instead. If your system is not capable of sending anything else but
   * `GET` requests, this method is your last resort. It allows you to create
   * and update missions with basic information using `GET` requests.
   *
   * You need to pass your API key as the query parameter `apiKey` with every
   * request.
   *
   * You cannot create or update mission actions, reports or resources with this
   * method.
   *
   * We identify missions with the combination of your API key and the query
   * parameter `externalId`. The mapping will be kept for at least 24 hours after
   * the last update to the mission.
   *
   * **Note:** Using a GET method to mutate data is a _very_ dirty hack that we only
   * provide for integration with systems that don't allow configuration of more
   * diverse HTTP verbs or request headers. It comes with many problems and caveats
   * and must only used as a last resort. You have been warned.
   *
   * @param externalId The ID of the mission in your system.
   * @param message
   * @param groupIds Comma-separated list of group IDs to add the mission to.
   * If left empty, the mission will be created/updated for all group IDs the API key has access to.
   *
   * @param keyword
   * @param editable
   * @param privileges
   * @param address
   * @param object
   * @param planNo
   * @param reporter
   * @param info
   * @param commander
   * @param recorder
   * @param coordinates Coordinates in the format `lat,lon`
   * @returns Mission The mission was successfully created or updated.
   * @throws ApiError
   */
  public getPutMission(
    externalId: string,
    message: string,
    groupIds?: string,
    keyword?: string,
    editable: boolean = true,
    privileges: boolean = false,
    address?: string,
    object?: string,
    planNo?: string,
    reporter?: string,
    info?: string,
    commander?: string,
    recorder?: string,
    coordinates?: string,
  ): CancelablePromise<Mission> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/get/put-mission',
      query: {
        'externalId': externalId,
        'message': message,
        'groupIds': groupIds,
        'keyword': keyword,
        'editable': editable,
        'privileges': privileges,
        'address': address,
        'object': object,
        'planNo': planNo,
        'reporter': reporter,
        'info': info,
        'commander': commander,
        'recorder': recorder,
        'coordinates': coordinates,
      },
      errors: {
        401: `The request was not authorized. Most likely you forgot to send the API key in the header \`Authorization\`.`,
        403: `You are not allowed to perform the requested operation on this resource.`,
      },
    });
  }

}
